<template>
  <div>
    <validation-observer
      @submit.prevent="submit"
      ref="commentBox"
      tag="form"
      v-slot="{ valid }"
    >
      <validation-provider
        vid="comment"
        rules="required|min:3|max:1500"
        name="comment"
        v-slot="{ errors }"
      >
        <b-field :message="errors" :type="{ 'is-danger': errors.length }">
          <b-input
            v-model="form.comment"
            type="textarea"
            placeholder="What are your thoughts?"
          />
        </b-field>
      </validation-provider>

      <div class="level">
        <div class="level-left"></div>
        <div class="level-rigth">
          <b-button
            :loading="submitting"
            :disabled="!valid || submitting"
            type="is-primary"
            native-type="submit"
          >
            <span>POST COMMENT</span>
          </b-button>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitting: false,
      form: {
        comment: ''
      }
    }
  },
  methods: {
    setSubmitting(submitting) {
      this.submitting = false
      this.form = {
        comment: ''
      }
      requestAnimationFrame(() => {
        this.$refs.commentBox.reset()
        this.opened = false
      })
    },
    submit() {
      this.submitting = true
      this.$emit('submit', this.form)
    }
  }
}
</script>
